import { PageNotFound } from "../../pages/status/PageNotFound";
import { PageUnauthorized } from "../../pages/status/PageUnauthorized";
import { RouteConfig } from "../types";

export const statusPageRoutes: { [key: string]: RouteConfig } = {
  pageNotFound: {
    path: "/*",
    component: PageNotFound,
    allowedRoles: [],
  },
  pageUnauthorized: {
    path: "/unauthorized",
    component: PageUnauthorized,
    allowedRoles: [],
  },
};
